import type { IconSvgObject } from './types';

const GeometricShapes02Icon: IconSvgObject = [
  ["circle", { cx: "6", cy: "6", r: "4", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 6H20.7929C21.2383 6 21.4614 6.53857 21.1464 6.85355L6.85355 21.1464C6.53857 21.4614 6 21.2383 6 20.7929V9.99998", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15.5 12.5H20C20.5523 12.5 21 12.9477 21 13.5V20.5C21 21.0523 20.5523 21.5 20 21.5H13C12.4477 21.5 12 21.0523 12 20.5V16", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GeometricShapes02Icon;
